import React from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AuthShell from "@/components/auth/AuthShell";
import { AUTH_FOOTER_LINK_CLASS } from "@/components/auth/authStyles";
import StepProgress, {
  getActiveStepIndex,
  type AuthStep,
} from "@/components/auth/StepProgress";

const STEPS: AuthStep[] = [
  { path: "/business/signup", label: "Account" },
  { path: "/business/signup/verify", label: "Email" },
  { path: "/business/signup/phone", label: "Phone" },
  { path: "/business/signup/profile", label: "Photo" },
  { path: "/business/signup/business-info", label: "Business" },
  { path: "/business/signup/plan", label: "Plan" },
];

/**
 * Business signup shell — the same two-panel auth layout the login page and
 * the student signup flow use, with the 6-step progress indicator above the
 * current step and the login escape hatch below it. The success page
 * (`/business/signup/success`) renders outside this layout.
 */
const BusinessSignupLayout: React.FC = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const currentIndex = getActiveStepIndex(pathname, STEPS);

  return (
    <AuthShell contentClassName="max-w-xl">
      <StepProgress steps={STEPS} currentIndex={currentIndex} />

      <Outlet />

      {/* Login escape hatch — the full prompt on step 1, a bare link once the
          flow has started (mirrors the login page's footer link). */}
      <div className="mt-6 text-center text-sm text-gray-500">
        {currentIndex === 0 && (
          <>
            {t("ALREADY HAVE AN ACCOUNT?")}{" "}
          </>
        )}
        <Link to="/business/login" className={AUTH_FOOTER_LINK_CLASS}>
          {t("Log In")}
        </Link>
      </div>
    </AuthShell>
  );
};

export default BusinessSignupLayout;
